mutation acknowledgeDefaultSenderVerification($companyId: ID!) {
  defaultSender: acknowledgeDefaultSenderVerification(companyId: $companyId) {
    id
    isVerified
    isAcknowledged
    fromEmail
    name
  }
}
